import { FormControl } from "@angular/forms";
import { SelectOption } from "../../../../core/interfaces/select-option";

export class RegLookupControlResultsModalListItem {

    constructor(
        protected label: string,
        protected formControl: FormControl,
        protected options?: Array<SelectOption>
    ) {

    }

    getLabel(): string {
        return this.label;
    }

    getValue(): string {
        return this.formControl.value;
    }

    getType(): string {
        if (this.getOptions().length > 1) {
            return "select";
        } else {
            return "text";
        }
    }

    getFormControl(): FormControl {
        return this.formControl;
    }

    getOptions(): Array<SelectOption> {
        return this.options || [];
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/reglookup/form/reg-lookup-control-results-modal-item.model.ts